import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import DrawingBoard from './features/drawingBoard/DrawingBoard';
import InputSlider from './features/drawingBoard/inputSlider';
import Graphic from './features/graphic/Graphic';
import { 
  setPower,
  setKSpringOne,
  setPresetSpringOne,
  setKSpringTwo,
  setPositionSpringTwo,
  toggleIdealCurve,
  toggleSpringCurve,
  toggleDoubleSpring,
  selectPower,
  selectKSpringOne,
  selectPresetSpringOne,
  selectKSpringTwo,
  selectPositionSpringTwo,
  selectShowIdealCurve,
  selectShowSpringCurve,
  selectDoubleSpring
} from './features/drawingBoard/drawingBoardSlice';
import styles from './App.module.css';

function App() {
  const power = useSelector(selectPower);
  const kSpringOne = useSelector(selectKSpringOne);
  const presetSpringOne = useSelector(selectPresetSpringOne);
  const kSpringTwo = useSelector(selectKSpringTwo);
  const positionSpringTwo = useSelector(selectPositionSpringTwo);
  const showIdealCurve = useSelector(selectShowIdealCurve);
  const showSpringCurve = useSelector(selectShowSpringCurve);
  const doubleSpring = useSelector(selectDoubleSpring);
  const dispatch = useDispatch();
  const handlePowerChange = (e) => {
    dispatch(setPower(+e.target.value));
  };
  const handleKSpringOneChange = (e) => {
    dispatch(setKSpringOne(+e.target.value));
  };
  const handlePresetSpringOneChange = (e) => {
    dispatch(setPresetSpringOne(+e.target.value));
  };
  const handleKSpringTwoChange = (e) => {
    dispatch(setKSpringTwo(+e.target.value));
  };
  const handlePositionSpringTwoChange = (e) => {
    dispatch(setPositionSpringTwo(+e.target.value));
  };
  const handleToggleIdealCurve = () => {
    dispatch(toggleIdealCurve());
  };
  const handleToggleSpringCurve = () => {
    dispatch(toggleSpringCurve());
  };
  const handleToggleDoubleSpring = () => {
    dispatch(toggleDoubleSpring());
  };
  const set5kW = () => {
    dispatch(setKSpringOne(0.9));
    dispatch(setKSpringTwo(9.7));
    dispatch(setPresetSpringOne(24));
    dispatch(setPositionSpringTwo(28));
    dispatch(setPower(5));
  };
  const set10kW = () => {
    dispatch(setKSpringOne(1.3));
    dispatch(setKSpringTwo(4.3));
    dispatch(setPresetSpringOne(54));
    dispatch(setPositionSpringTwo(43));
    dispatch(setPower(10));
  };
  const set15kW = () => {
    dispatch(setKSpringOne(1.7));
    dispatch(setKSpringTwo(2));
    dispatch(setPresetSpringOne(81));
    dispatch(setPositionSpringTwo(53));
    dispatch(setPower(15));
  };
  return (
    <div>
      <DrawingBoard
        width="90%"
        height={500}
      >
        <Graphic />
      </DrawingBoard>
      <div>
        <div className={styles.buttonsContainer}>
          <div className={styles.sliderLabel}>Ideal Power Curve</div>
          <button 
            className={styles.optionsButton}
            onClick={handleToggleIdealCurve}
          >
            {showIdealCurve? "Hide" : "Show"}
          </button>
        </div>
        {showIdealCurve ? 
          <InputSlider 
            label="kW"
            display={power}
            max={15}
            min={1}
            step={0.1}
            onChange={handlePowerChange}
            value={power}
          />
        : null}
        <div className={styles.buttonsContainer}>
          <div className={styles.sliderLabel}>Spring Feedback Power Curve</div>
          <button 
            className={styles.optionsButton}
            onClick={handleToggleSpringCurve}
          >{showSpringCurve ? "Hide" : "Show"}</button>
          {showSpringCurve ? 
            <button 
              className={styles.optionsButton}
              onClick={handleToggleDoubleSpring}
            >{doubleSpring ? "Show Single Spring" : "Show Double Spring"}</button>
          : null}
          {doubleSpring && showSpringCurve ? 
            <button
              className={styles.optionsButton}
              onClick={set5kW}
            >5 kW</button>
          : null}
          {doubleSpring && showSpringCurve ? 
            <button
              className={styles.optionsButton}
              onClick={set10kW}
            >10 kW</button>
          : null}
          {doubleSpring && showSpringCurve ? 
            <button
              className={styles.optionsButton}
              onClick={set15kW}
            >15 kW</button>  
          : null}
        </div>
        {showSpringCurve ? 
          <div>
            <InputSlider 
              label="Spring1 Constant"
              display={kSpringOne}
              max={10}
              min={0.1}
              step={0.1}
              onChange={handleKSpringOneChange}
              value={kSpringOne}
            />
            <InputSlider 
              label="Spring1 preset"
              display={presetSpringOne}
              max={150}
              min={0}
              step={1}
              onChange={handlePresetSpringOneChange}
              value={presetSpringOne}
            />
          </div>
        :null}
        {showSpringCurve && doubleSpring ? 
        <div>
          <InputSlider 
            label="Spring2 Constant"
            display={kSpringTwo}
            max={10}
            min={0.1}
            step={0.1}
            onChange={handleKSpringTwoChange}
            value={kSpringTwo}
          />
          <InputSlider 
            label="Spring2 Position"
            display={positionSpringTwo}
            max={90}
            min={20}
            step={1}
            onChange={handlePositionSpringTwoChange}
            value={positionSpringTwo}
          />
        </div>
        : null}
      </div>
    </div>
  );
}

export default App;
